import { render, staticRenderFns } from "./sifreSifirlamaMenu.vue?vue&type=template&id=cd72fc02&scoped=true"
import script from "./sifreSifirlamaMenu.vue?vue&type=script&lang=js"
export * from "./sifreSifirlamaMenu.vue?vue&type=script&lang=js"
import style0 from "./sifreSifirlamaMenu.vue?vue&type=style&index=0&id=cd72fc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd72fc02",
  null
  
)

export default component.exports